import React from "react";
import "../style/Home.css";
import cfdFailed from "../static/images/NoCFDResults.png"
import { Container } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button, ButtonGroup } from "react-bootstrap";
import { useState, useReducer } from "react";
import VTKScene from "./VTKScene";
import CFILinePlot from "./CFILinePlot";
import DcmCarousel from "./DcmCarousel";
import SimulationMovie from "./SimulationMovie";
import { useEffect } from "react";
import { ToggleButton } from "react-bootstrap";



// TODO : Date of birth hidden as date picker not workjing

// This was a bit complicated. 
// Have a reduced that sets plot data and simulation data (DMC and vel paths) one change of dropdown.
// But only on click update will this be used to set simAB state.
// The useEffect used to set isReady state to update comaprison and rerender.  

const initialState = {
    simA: undefined,
    simB: undefined,
    plotDataObjA: undefined,
    plotDataObjB: undefined
};


const selectReducer = (state, action) => {
    let newState = { ...state };
    switch (action.type) {
        case 'updateA':
            state.simulations.forEach((iSimulation) => {
                if (iSimulation.id.toString() === action.simValue.toString()) {
                    if (iSimulation.hasDicoms) {
                        newState.simA = iSimulation;
                    };
                    try {
                        newState.plotDataObjA = {};
                        newState.plotDataObjA.U = {
                            xArray: newState.simA.data.d,
                            yArray: newState.simA.data.U,
                            xLabel: newState.simA.data.Labels.d,
                            yLabel: newState.simA.data.Labels.U,
                            color: '#FF1100',
                            step: 5,
                            dataLabel: "Velocity " + newState.simA.simulationID
                        };
                        newState.plotDataObjA.p = {
                            xArray: newState.simA.data.d,
                            yArray: newState.simA.data.p,
                            xLabel: newState.simA.data.Labels.d,
                            yLabel: newState.simA.data.Labels.p,
                            color: '#F800FF',
                            step: 0.2,
                            dataLabel: "Pressure " + newState.simA.simulationID
                        };
                    }
                    catch (error) {
                        newState.plotDataObjA = false;
                    };
                }
            }
            );
            return newState;

        case 'updateB':
            state.simulations.forEach((iSimulation) => {
                if (iSimulation.id.toString() === action.simValue.toString()) {
                    if (iSimulation.hasDicoms) {
                        newState.simB = iSimulation;
                    };
                    try {
                        newState.plotDataObjB = {}
                        newState.plotDataObjB.U = {
                            xArray: newState.simB.data.d,
                            yArray: newState.simB.data.U,
                            xLabel: newState.simB.data.Labels.d,
                            yLabel: newState.simB.data.Labels.U,
                            color: '#0008FF',
                            step: 5,
                            dataLabel: "Velocity " + newState.simB.simulationID
                        };
                        newState.plotDataObjB.p = {
                            xArray: newState.simB.data.d,
                            yArray: newState.simB.data.p,
                            xLabel: newState.simB.data.Labels.d,
                            yLabel: newState.simB.data.Labels.p,
                            color: '#00D8FF',
                            step: 0.2,
                            dataLabel: "Pressure " + newState.simB.simulationID
                        };
                    } catch (error) {
                        newState.plotDataObjB = false;
                    };
                }
            }
            );


            return newState;
        default:
            return newState;
    }

}



const StudyProfile = ({ study, user }) => {
    const [dispState, dispatchState] = useReducer(selectReducer, {
        ...initialState,
        simulations: study.simulations
    });

    const [simAB, setSimAB] = useState([undefined, undefined, undefined, undefined]);
    // Arrayx4 - simA and simB --> serSimA, serSimB, plotObjA, plotObjB

    const [isReady, setIsReady] = useState(false);
    const [playPause, setPlayPause] = useState(false); // true is play | false is pause
    // const [activeIndex, setActiveIndex] = useState(0);
    const [VelOrPress, setVelOrPress] = useState('VELOCITY');

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsReady(false);
        let eA = document.getElementById("SimASelect"+study.studyID);
        let valueA = eA.value;
        let eB = document.getElementById("SimBSelect"+study.studyID);
        let valueB = eB.value;
        console.log('Update comparison with ', valueA, ' vs ', valueB);
        if (valueA && valueB && !valueA.includes('Choose') && !valueB.includes('Choose')) {
            setSimAB([dispState.simA, dispState.simB, dispState.plotDataObjA, dispState.plotDataObjB])
        }
    };

    useEffect(() => {
        simAB[0] && simAB[1] && setIsReady(true);
    }, [simAB]);

    const handleChangeA = event => {
        dispatchState({
            type: 'updateA', simValue: event.target.value,
        });
    };

    const handleChangeB = event => {
        dispatchState({
            type: 'updateB', simValue: event.target.value,
        });
    };

    const switchVelPress = event => {
        if (VelOrPress === 'VELOCITY') {
            setVelOrPress('PRESSURE');
        }
        else {
            setVelOrPress('VELOCITY');
        }
    }

    const playCarousel = event => {
        setPlayPause(!playPause);
    }
    // const resetSync = event => {
    //     setActiveIndex(0);
    // }

    // useEffect(() => {
    //     for (let i = 0; i < study.simulations.length; i++) {
    //         studyScenes[study.simulations[i].id] = <VTKScene id={"CmpVTK" + study.simulations[i].id} url={'/api/download/trainee/' + study.simulations[i].id + '/VELOCITY'} showButtons={false} ></VTKScene>
    //     }
    // }, []);


    return (
        <Container className="mb-5">
            <h3>Profile {user.name} </h3>

            <Row>
                <div className="col-lg-5 border border-dark mx-1 rounded">
                    <p> Study overview page for {user.name}</p>
                    <p> Study is: {study.studyName}</p>
                    <p> Select 2 simulations to compare</p>
                </div>
            </Row>

            <Row>
                <h3 className="my-3">Comparison of simulations</h3>
            </Row>

            <Row>
                <Form onSubmit={handleSubmit} >
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridCFDA">
                            <Form.Label>Simulation A</Form.Label>
                            <Form.Select size="sm" id={"SimASelect"+study.studyID} onChange={handleChangeA}>
                                <option key="ChooseA" value={null}>Choose Simulation A</option>
                                {study.simulations.map(
                                    (iSimulation) =>
                                        (iSimulation.trainee_id === user.id) && iSimulation.hasDicoms && (
                                            <option key={'A' + iSimulation.simulationID} value={iSimulation.id}>{iSimulation.simulationID}</option>
                                        )
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridCFDB">
                            <Form.Label>Simulation B</Form.Label>
                            <Form.Select size="sm" id={"SimBSelect"+study.studyID} onChange={handleChangeB}>
                                <option key="ChooseB" value={null}>Choose Simulation B</option>
                                {study.simulations.map(
                                    (iSimulation) =>
                                        (iSimulation.trainee_id === user.id) && iSimulation.hasDicoms && (
                                            <option key={'B' + iSimulation.simulationID} value={iSimulation.id}>{iSimulation.simulationID}</option>
                                        )
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridCFDSubmit">
                            <Button type="submit" className="mt-5">
                                Update
                            </Button>
                        </Form.Group>
                    </Row>
                </Form>
            </Row>

            {isReady &&
                <Container>
                    <div className="border border-dark rounded-2 m-3">
                        <Row className="m-1">
                            <Col>
                                <Row>
                                    <DcmCarousel id="CmpDcmA" simulation={simAB[0]} playing={playPause} interactive={false}></DcmCarousel>
                                </Row>
                                <Row>
                                    <figcaption>{simAB[0].simulationID}</figcaption>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <DcmCarousel id="CmpDcmB" simulation={simAB[1]} playing={playPause} interactive={false}></DcmCarousel>
                                </Row>
                                <Row>
                                    <figcaption>{simAB[1].simulationID}</figcaption>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <ButtonGroup aria-label="Carousel-buttongroup">
                                <Button variant="primary" onClick={playCarousel}>{playPause ? "Pause" : "Play"}</Button>
                                {/* <Button variant="primary" onClick={resetSync}>Reset syncronisation</Button> */}
                            </ButtonGroup>
                        </Row>
                    </div>
                        <div className="border border-dark rounded-2 m-3">
                            <Row className="my-1">
                                <Col>
                                    {simAB[2] ?
                                        VelOrPress === 'VELOCITY' ?
                                            <VTKScene id="CmpVTKA-Vel" key="CmpVTKA-Vel" url={'/api/download/trainee/' + simAB[0].id + '/VELOCITY'} showButtons={false} viewWidth={500} ></VTKScene>
                                            :
                                            <VTKScene id="CmpVTKA-Press" key="CmpVTKA-Press" url={'/api/download/trainee/' + simAB[0].id + '/PRESSURE'} showButtons={false} viewWidth={500} ></VTKScene>
                                        :
                                        <img src={cfdFailed} className="img-thumbnail" alt="no flow results"></img>
                                    }                                
                                </Col>
                                <Col>
                                    {simAB[3] ?
                                        VelOrPress === 'VELOCITY' ?
                                            <VTKScene id="CmpVTKB-Vel" key="CmpVTKB-Vel" url={'/api/download/trainee/' + simAB[1].id + '/VELOCITY'} showButtons={false} viewWidth={500} ></VTKScene>
                                            :
                                            <VTKScene id="CmpVTKB-Press" key="CmpVTKB-Press" url={'/api/download/trainee/' + simAB[1].id + '/PRESSURE'} showButtons={false} viewWidth={500} ></VTKScene>
                                        :
                                        <img src={cfdFailed} className="img-thumbnail" alt="no flow results"></img>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <figcaption>{simAB[0].simulationID}</figcaption>
                                </Col>
                                <Col>
                                    <figcaption>{simAB[1].simulationID}</figcaption>
                                </Col>
                            </Row>
                            <Row>
                                <ButtonGroup aria-label="VTKScene-buttongroup">
                                    <ToggleButton
                                        id="toggle-check-vel"
                                        type="checkbox"
                                        variant={VelOrPress === 'VELOCITY' ? "primary" : "outline-primary"}
                                        checked={VelOrPress === 'VELOCITY'}
                                        value="1"
                                        onChange={(e) => switchVelPress(e.currentTarget.checked)}>
                                        VELOCITY
                                    </ToggleButton>
                                    <ToggleButton
                                        id="toggle-check-press"
                                        type="checkbox"
                                        variant={VelOrPress === 'PRESSURE' ? "primary" : "outline-primary"}
                                        checked={VelOrPress === 'PRESSURE'}
                                        value="1"
                                        onChange={(e) => switchVelPress(e.currentTarget.checked)}>
                                        PRESSURE
                                    </ToggleButton>
                                </ButtonGroup>
                            </Row>
                        </div>
                    <Row className="my-3">
                        {simAB[2] || simAB[3] ?
                        <Col>
                            {simAB[2] && simAB[3] && VelOrPress === 'VELOCITY' ?
                                <CFILinePlot id="CmpLinePlotUA" dataObjA={[simAB[2].U, simAB[3].U]}></CFILinePlot>
                                :
                                <CFILinePlot id="CmpLinePlotpA" dataObjA={[simAB[2].p, simAB[3].p]}></CFILinePlot>
                            }

                        </Col>
                        :
                        <p>No flow dynamics results to plot</p>
                        }
                    </Row>
                    <div className="border border-dark rounded-2 m-3">
                    <Row className="my-1">
                        <Row>
                            <Col>
                                <VTKScene id="CmpVTKA-StitV" key="CmpVTKA-StitV" url={'/api/download/trainee/' + simAB[0].id + '/STITCHESVTKJS'} showButtons={false} viewWidth={500} ></VTKScene>
                            </Col>
                            <Col>
                                <VTKScene id="CmpVTKB-StitV" key="CmpVTKB-StitV" url={'/api/download/trainee/' + simAB[1].id + '/STITCHESVTKJS'} showButtons={false} viewWidth={500} ></VTKScene>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <img src={'/api/download/trainee/' + simAB[0].id + '/STITCHESPNG' } className="img-thumbnail" alt="no stitches results"></img>
                            </Col>
                            <Col>
                                <img src={'/api/download/trainee/' + simAB[1].id + '/STITCHESPNG' } className="img-thumbnail" alt="no stitches results"></img>
                            </Col>
                        </Row>
                    </Row>
                    <Row>
                        <Col>
                            <figcaption>{simAB[0].simulationID}</figcaption>
                        </Col>
                        <Col>
                            <figcaption>{simAB[1].simulationID}</figcaption>
                        </Col>
                    </Row>
                    </div>
                    <div className="border border-dark rounded-2 m-3">
                        <Row className="my-2">
                            <Row>
                                <SimulationMovie key={'CmpSimMovieA'+user.id+simAB[0].id} simulation={simAB[0]}></SimulationMovie>
                            </Row>
                            <Row>
                                <figcaption>{simAB[0].simulationID}</figcaption>
                            </Row>
                        </Row>
                        <Row className="my-2">
                            <Row>
                                <SimulationMovie key={'CmpSimMovieA'+user.id+simAB[1].id} simulation={simAB[1]}></SimulationMovie>
                            </Row>
                            <Row>
                                <figcaption>{simAB[1].simulationID}</figcaption>
                            </Row>
                        </Row>
                    </div>
                </Container>
                // : errorMsg &&
                // <p>{errorMsg}</p>
            }

        </Container>
    );
};

export default StudyProfile;
